import React from 'react';
import PatternLibModalComponent from '../../common/modals/PatternLibModalComponent';
import StringConstant from '../../../constants/StringConstants';

class ViewArchiveComponent extends React.Component {
  constructor(props) {
    super(props);
    this.modalBodyStanding = this.modalBodyStanding.bind(this);
    this.modalBodyDirect = this.modalBodyDirect.bind(this);
    this.modalBodyDirect = this.modalBodyDirect.bind(this);
    this.renderDirectDebit = this.renderDirectDebit.bind(this);
    this.renderStandingOrder = this.renderStandingOrder.bind(this);
    this.renderView = this.renderView.bind(this);
  }

  modalBodyStanding() {
    const fromData = `${this.props.archieveData.fromAccountName}-${this.props.archieveData.fromAccountNumber}`;
    return (
      <dl className="c-definitions">
        <dt className="c-definitions__key">From</dt>
        <dd className="c-definitions__value">{fromData}</dd>
        <dt className="c-definitions__key">To</dt>
        <dd className="c-definitions__value">
          {this.props.archieveData.toAccountName}
        </dd>
        <dt className="c-definitions__key">Their sort code</dt>
        <dd className="c-definitions__value">
          {this.props.archieveData.sortCode}
        </dd>
        <dt className="c-definitions__key">Their account number</dt>
        <dd className="c-definitions__value">
          {this.props.archieveData.accountNumber}
        </dd>
        <dt className="c-definitions__key">Reference</dt>
        <dd className="c-definitions__value">
          {this.props.archieveData.reference}
        </dd>
      </dl>
    );
  }
  renderDirectDebit() {
    return (
      <PatternLibModalComponent
        customClass={'c-modal'}
        show
        onHide={this.props.closeModal}
        bsSize={'large'}
        modalHeading={'Archived Direct Debit'}
        modalBody={this.modalBodyDirect()}
        modalInContainer={false}
        modalFooter={
          <div>
            <button
              onClick={this.props.closeModal}
              className="c-btn c-btn--default c-modal__button"
            >
              Close
            </button>
          </div>
        }
      />
    );
  }
  modalBodyDirect() {
    const fromData = `${this.props.archieveData.fromAccountName}-${this.props.archieveData.fromAccountNumber}`;
    return (
      <dl className="c-definitions">
        <dt className="c-definitions__key">From</dt>
        <dd className="c-definitions__value">{fromData}</dd>
        <dt className="c-definitions__key">To</dt>
        <dd className="c-definitions__value">
          {this.props.archieveData.toAccountName}
        </dd>
        <dt className="c-definitions__key">Reference</dt>
        <dd className="c-definitions__value">
          {this.props.archieveData.reference}
        </dd>
      </dl>
    );
  }
  renderStandingOrder() {
    let modalHeader = `Archived ${this.props.archieveData.paymentType}`;

    if (this.props.archieveData.paymentType === StringConstant.SOText) {
      modalHeader = 'Archived standing order';
    }
    return (
      <PatternLibModalComponent
        customClass={'c-modal'}
        show
        onHide={this.props.closeModal}
        bsSize={'large'}
        modalHeading={modalHeader}
        modalBody={this.modalBodyStanding()}
        modalInContainer={false}
        modalFooter={
          <div>
            <button
              onClick={this.props.closeModal}
              className="c-btn c-btn--default c-modal__button"
            >
              Close
            </button>
          </div>
        }
      />
    );
  }
  renderView() {
    if (this.props.archieveData.type === StringConstant.DirectDebit) {
      return this.renderDirectDebit();
    } else {
      return this.renderStandingOrder();
    }
  }
  render() {
    const renderView = this.renderView();
    return renderView;
  }
}
export default ViewArchiveComponent;
